// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for the reusable text autocomplete dropdown panel.
 */
.mydocma-text-autocomplete-dropdown {
  position: absolute;
  z-index: 10000;
  padding: 8px 0;
  min-width: 150px;
  max-height: 180px;
  overflow: auto;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.mydocma-text-autocomplete-group-label {
  position: relative;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #343E48;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  padding: 8px 16px;
}

.mydocma-text-autocomplete-group-label + .mydocma-text-autocomplete-item {
  scroll-margin-top: 40px;
}

.mydocma-text-autocomplete-item {
  -webkit-appearance: none;
          appearance: none;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  width: 100%;
  padding: 8px 16px;
  height: 32px;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  border-radius: 0;
}
.mydocma-text-autocomplete-item.nested {
  padding: 8px 16px 8px 36px;
}
.mydocma-text-autocomplete-item:disabled {
  cursor: default;
  opacity: 0.2;
}
.mydocma-text-autocomplete-item:not(:disabled):hover, .mydocma-text-autocomplete-item:not(:disabled).focused {
  background: #F6F7F8;
}

.mydocma-text-autocomplete-item-value {
  color: #343E48;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.mydocma-text-autocomplete-item-description {
  color: #9DA1A6;
  font-weight: 400;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::ng-deep .mydocma-text-autocomplete-highlight {
  font-weight: bolder;
  color: var(--mydocma-color-grey1);
}`, "",{"version":3,"sources":["webpack://./projects/mydocma/dynamic-form/src/lib/autocomplete/text-autocomplete-panel/text-autocomplete-panel.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/projects/mydocma/dynamic-form/src/lib/autocomplete/text-autocomplete-panel/text-autocomplete-panel.component.scss"],"names":[],"mappings":"AAAA;;EAAA;AAGA;EACI,kBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,uBAAA;ACCJ;;ADEA;EACI,wBAAA;UAAA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ACCJ;ADCI;EACI,0BAAA;ACCR;ADEI;EACI,eAAA;EACA,YAAA;ACAR;ADGI;EAEI,mBAAA;ACFR;;ADMA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;ACHJ;;ADMA;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ACHJ;;ADMA;EACI,mBAAA;EACA,iCAAA;ACHJ","sourcesContent":["/**\r\n * Styles for the reusable text autocomplete dropdown panel.\r\n */\r\n.mydocma-text-autocomplete-dropdown {\r\n    position: absolute;\r\n    z-index: 10000;\r\n    padding: 8px 0;\r\n    min-width: 150px;\r\n    max-height: 180px;\r\n    overflow: auto;\r\n    background: #fff;\r\n    border-radius: 4px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.mydocma-text-autocomplete-group-label {\r\n    position: relative;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    color: #343E48;\r\n    font-family: Roboto;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 16px;\r\n    padding: 8px 16px;\r\n}\r\n\r\n.mydocma-text-autocomplete-group-label + .mydocma-text-autocomplete-item {\r\n    scroll-margin-top: 40px;\r\n}\r\n\r\n.mydocma-text-autocomplete-item {\r\n    appearance: none;\r\n    border: none;\r\n    background: transparent;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    padding: 8px 16px;\r\n    height: 32px;\r\n    display: flex;\r\n    gap: 8px;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    border-radius: 0;\r\n\r\n    &.nested {\r\n        padding: 8px 16px 8px 36px;\r\n    }\r\n\r\n    &:disabled {\r\n        cursor: default;\r\n        opacity: 0.2;\r\n    }\r\n\r\n    &:not(:disabled):hover,\r\n    &:not(:disabled).focused {\r\n        background: #F6F7F8;\r\n    }\r\n}\r\n\r\n.mydocma-text-autocomplete-item-value {\r\n    color: #343E48;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 16px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    min-width: fit-content;\r\n}\r\n\r\n.mydocma-text-autocomplete-item-description {\r\n    color: #9DA1A6;\r\n    font-weight: 400;\r\n    line-height: 16px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n::ng-deep .mydocma-text-autocomplete-highlight {\r\n    font-weight: bolder;\r\n    color: var(--mydocma-color-grey1);\r\n}\r\n","/**\n * Styles for the reusable text autocomplete dropdown panel.\n */\n.mydocma-text-autocomplete-dropdown {\n  position: absolute;\n  z-index: 10000;\n  padding: 8px 0;\n  min-width: 150px;\n  max-height: 180px;\n  overflow: auto;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.mydocma-text-autocomplete-group-label {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #343E48;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n  padding: 8px 16px;\n}\n\n.mydocma-text-autocomplete-group-label + .mydocma-text-autocomplete-item {\n  scroll-margin-top: 40px;\n}\n\n.mydocma-text-autocomplete-item {\n  appearance: none;\n  border: none;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  width: 100%;\n  padding: 8px 16px;\n  height: 32px;\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  border-radius: 0;\n}\n.mydocma-text-autocomplete-item.nested {\n  padding: 8px 16px 8px 36px;\n}\n.mydocma-text-autocomplete-item:disabled {\n  cursor: default;\n  opacity: 0.2;\n}\n.mydocma-text-autocomplete-item:not(:disabled):hover, .mydocma-text-autocomplete-item:not(:disabled).focused {\n  background: #F6F7F8;\n}\n\n.mydocma-text-autocomplete-item-value {\n  color: #343E48;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: fit-content;\n}\n\n.mydocma-text-autocomplete-item-description {\n  color: #9DA1A6;\n  font-weight: 400;\n  line-height: 16px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n::ng-deep .mydocma-text-autocomplete-highlight {\n  font-weight: bolder;\n  color: var(--mydocma-color-grey1);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
